// Opisto expresses `shippingDelayMax` in days.
const HOURS_PER_DAY = 24;

export const getShippingDelayMaxHours = (shippingDelayMax: number | undefined | null): number | undefined =>
  shippingDelayMax == null ? undefined : shippingDelayMax * HOURS_PER_DAY;
